<template>
  <div>
    <DemandMaterialTable :orderCode="orderCode" />
  </div>
</template>

<script>
import DemandMaterialTable from './components/table'
export default {
  components: { DemandMaterialTable },
  props: {
    orderCode: { type: String, default: '' },
  },
}
</script>
